import {Injectable} from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class DatesParserService {

    constructor() {
    }

    cleanDates(params: Object, fields: Array<string>): Object {
        fields.forEach(function (field) {
            // if (moment.isMoment(piter)) {
            //     console.log('momento');
                params[field] = moment.utc(params[field]).format('YYYY-MM-DD HH:mm:ss');
            // }
            // else{
            //     console.log('no momento');
            //     delete params[field];
            // }
        });

        return params;
    }
}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/core/service/dates_parser.service.ts